export class PatientQuickSearchResult {
    patientId: number;
    patientCode: string;
    fullName: string;
    telCode: string;
    secondPhoneNumber: string;
    documentCode: string;
    nationalCode: string;
    isMasked: boolean;
}